import { defineStore } from 'pinia'
import { ref } from 'vue'
import { VipAPI } from '@/services/vip'

export const useVipStore = defineStore('vip', () => {
  // 🔧 初始化时从 localStorage 读取
  const initVipUltraPackage = () => {
    try {
      const ultraPkg = localStorage.getItem('vip_ultra_package')
      if (ultraPkg) {
        const parsed = (ultraPkg)
        return typeof parsed === 'string' ? parsed : parsed || ''
      }
    } catch (error) {
      console.error('读取 VIP Ultra 包信息失败:', error)
    }
    return ''
  }

  const initVipPlusPackage = () => {
    try {
      const plusPkg = localStorage.getItem('vip_plus_package')
      if (plusPkg) {
        console.log(plusPkg);
        const parsed = (plusPkg)
        return typeof parsed === 'string' ? parsed : parsed || ''
      }
    } catch (error) {
      console.error('读取 VIP Plus 包信息失败:', error)
    }
    return ''
  }

  const vipUltraPackage = ref<string>(initVipUltraPackage())
  const vipPlusPackage = ref<string>(initVipPlusPackage())
  
  // VIP 权益数据
  const vipPerks = ref<any>({})
  const vipPerksLoading = ref(false)
  const vipPerksInitialized = ref(false)

  // 🔧 保留函数形式以兼容现有代码，但不修改响应式数据（避免递归更新）
  const getVipPlusPackage = () => {
    vipPlusPackage.value = localStorage.getItem('vip_plus_package') || ''
    return vipPlusPackage.value
  }
  const setVipPlusPackage = (packageIndex: number) => {
    const packageName = packageIndex === 0 ? 'Monthly' : packageIndex === 1 ? 'Season' : 'Year'
    localStorage.setItem('vip_plus_package', JSON.stringify(packageName))
    vipPlusPackage.value = packageName
  }
  const getVipUltraPackage = () => {
    vipUltraPackage.value = localStorage.getItem('vip_ultra_package') || ''
    return vipUltraPackage.value
  }
  const setVipUltraPackage = (packageIndex: number) => {
    const packageName = packageIndex === 0 ? 'Monthly' : packageIndex === 1 ? 'Quarterly' : 'Yearly'
    localStorage.setItem('vip_ultra_package', JSON.stringify(packageName))
    vipUltraPackage.value = packageName
  }

  /**
   * 获取 VIP 权益数据
   */
  const fetchVipPerks = async () => {
    try {
      vipPerksLoading.value = true
      const res = await VipAPI.getVipPerks()
      vipPerks.value = res?.data || {}
      vipPerksInitialized.value = true
      return vipPerks.value
    } catch (error) {
      console.error('获取 VIP 权益失败:', error)
      throw error
    } finally {
      vipPerksLoading.value = false
    }
  }

  /**
   * 刷新 VIP 权益数据
   */
  const refreshVipPerks = async () => {
    try {
      const res = await VipAPI.getVipPerks()
      vipPerks.value = res?.data || {}
      vipPerksInitialized.value = true
      return vipPerks.value
    } catch (error) {
      console.error('刷新 VIP 权益失败:', error)
      throw error
    }
  }

  return {
    vipUltraPackage,
    vipPlusPackage,
    vipPerks,
    vipPerksLoading,
    vipPerksInitialized,
    getVipUltraPackage,
    setVipUltraPackage,
    getVipPlusPackage,
    setVipPlusPackage,
    fetchVipPerks,
    refreshVipPerks
  }
})
